import styled from 'styled-components';

export const Box = styled.div`
    margin-top: 20px;
`;
